const prefix = 'cycles';

export const FETCH = `${prefix}/FETCH`;
export const FETCH_SUCCEEDED = `${prefix}/FETCH_SUCCEEDED`;
export const FETCH_FAILED = `${prefix}/FETCH_FAILED`;
